export default __webpack_public_path__ + "static/outlet_b.f834f78a322bc25a4320ea3dc08deaf0.png";